import React from "react";
import AboutPlaceholderUpper from "./AboutPlaceholderUpper";
import AboutPlaceholderLower from "./AboutPlaceholderLower";
function AboutPlaceholder () {
  return (
    <React.Fragment>
      <AboutPlaceholderUpper />
      <AboutPlaceholderLower />
    </React.Fragment>
  );
}
export default AboutPlaceholder;